import { useState } from 'react';
import { HoursData } from '../../../../datastore/hours.json';
import { MinutesData } from '../../../../datastore/minutes.json';

let _currentTime = sessionStorage.getItem('session_locationTime') === ''
  ? new Date()
  : new Date(sessionStorage.getItem('session_locationTime'));
let _currentHour = new Date(_currentTime).getHours();
let _currentMinute = new Date(_currentTime).getMinutes();

function buildInitialState(customer, tripDetails) {
  _currentTime = sessionStorage.getItem('session_locationTime') === ''
    ? new Date()
    : new Date(sessionStorage.getItem('session_locationTime'));
  _currentHour = new Date(_currentTime).getHours();
  _currentMinute = new Date(_currentTime).getMinutes();

  return {
    rideId: tripDetails == null ? 0 : tripDetails.rideId,
    affBookingNo: tripDetails == null ? '' : tripDetails.affBookingNo,
    customer,
    paxFirstName: '',
    paxLastName: '',
    countryCodePhone: '1',
    phoneNumber: '',
    countryCode: '1',
    mobileNumber: '',
    email: '',
    isSendEmail: false,

    dropdownAirline: [],
    airlineId: customer ? customer.airlineId : 0,
    flightNumber: '',
    terminalType: 1,
    terminal: '',
    pilotCount: 0,
    crewCount: 0,
    flightAttandCount: 0,

    airlineIdReturn: customer ? customer.airlineId : 0,
    flightNumberReturn: '',
    terminalTypeReturn: 1,
    terminalReturn: '',
    pilotCountReturn: 0,
    crewCountReturn: 0,
    flightAttandCountReturn: 0,

    poNumber: '',
    dropdownVehicleType: [],
    dropdownZone: [],
    bookingAddress: [],

    isPickupGoogleBooking: false,
    pickupSuggestions: [],
    pickupLocation: '',
    pickupZoneId: 0,
    pickupAddress: '',
    pickupAddressType: '',
    pickupCity: '',
    pickupState: '',
    pickupZipCode: '',
    pickupLatitude: 0,
    pickupLongitude: 0,
    isDropoffGoogleBooking: false,
    dropoffSuggestions: [],
    dropoffLocation: '',
    dropoffZoneId: 0,
    dropoffAddress: '',
    dropoffAddressType: '',
    dropoffCity: '',
    dropoffState: '',
    dropoffZipCode: '',
    dropoffLatitude: 0,
    dropoffLongitude: 0,
    serviceSourceId: 1,
    dropdownAffiliates: [],
    otherAffiliateId: 0,

    isVipTrip: false,
    isMeetGreet: false,
    isPriorityTrip: false,

    puDateTime: _currentTime,
    puDateTimeReturn: _currentTime,

    vehicleTypeId: 0,
    noOfTrip: 1,
    tripTypeId: '1',

    dropdownHours: HoursData,
    dropdownMinutes: MinutesData,
    flightHour: _currentHour,
    flightMinute: _currentMinute,
    flightTime: new Date(_currentTime.getFullYear(), _currentTime.getMonth(), _currentTime.getDate(), _currentHour, _currentMinute),
    flightHourReturn: _currentHour,
    flightMinuteReturn: _currentMinute,
    flightTimeReturn: new Date(_currentTime.getFullYear(), _currentTime.getMonth(), _currentTime.getDate(), _currentHour, _currentMinute),

    recurringTypeId: 2,
    recurringEndDate: '',
    selectedDays: [],
    isWeekSun: false,
    isWeekMon: false,
    isWeekTue: false,
    isWeekWed: false,
    isWeekThu: false,
    isWeekFri: false,
    isWeekSat: false,
    isMonthSun: false,
    isMonthMon: false,
    isMonthTue: false,
    isMonthWed: false,
    isMonthThu: false,
    isMonthFri: false,
    isMonthSat: false,

    specialInstruction: '',
    permanentRemark: '',
    pickupNotes: '',
    billToNotes: '',

    customerRateTax: null,
    loadPanelVisible: false,
    isCopy: false,
    isAttachment: false,
    notesTab: 'trip',

    totalFare: tripDetails == null ? 0 : tripDetails.totalFare,
    driverFees: tripDetails == null ? 0 : tripDetails.driverComm,
    driverComm: 0,

    errors: {
      paxFirstName: '',
      paxLastName: '',
      countryCode: '',
      mobileNumber: '',
      email: '',
      airlineId: '',
      flightNumber: '',
      terminalType: '',
      pilotCount: '',
      flightTime: '',
      airlineIdReturn: '',
      flightNumberReturn: '',
      terminalTypeReturn: '',
      pilotCountReturn: '',
      flightTimeReturn: '',
      pickupLocation: '',
      pickupZoneId: '',
      dropoffLocation: '',
      dropoffZoneId: '',
      otherAffiliateId: '',
      puDateTime: '',
      puDateTimeReturn: '',
      vehicleTypeId: '',
      noOfTrip: '',
      recurringEndDate: '',
      recurring: '',
    },
  };
}

export function useAirportState(customer, tripDetails) {
  const [state, setStateRaw] = useState(() => buildInitialState(customer, tripDetails));

  const setState = (partial) =>
    setStateRaw((prev) => ({
      ...prev,
      ...(typeof partial === 'function' ? partial(prev) : partial),
    }));

  return { state, setState };
}
